import React from 'react';
import DropDownSingle from '../../../../../Components/DropDownSingle';
import GeneralButton from '../../../../../Components/GeneralButton';
import { ACCESS_CONTROL_CONSTANTS } from '../../../../../core/constants';
const { SYSTEMS } = ACCESS_CONTROL_CONSTANTS;
const CreateVideoSectionWithCopyExisting = ({
	dropDownList,
	selectedExistingVideoSection,
	updateSelectedExistingVideoSection,
	createVideoSection
}) => {
	return (
		<div style={{ display: 'flex', justifyContent: 'center' }}>
			<DropDownSingle
				system={SYSTEMS.FVP_PLAYER}
				isObjectEditor={false}
				keyData={'ads.videoSectionIds'}
				list={dropDownList}
				formControlVariant="outlined"
				containerStyles={{ width: '100%' }}
				selectInputStyles={{ width: '40rem' }}
				directValue={selectedExistingVideoSection}
				updateDirectValue={(Id) => {
					updateSelectedExistingVideoSection(Id);
				}}
			/>

			<GeneralButton
				system={SYSTEMS.FVP_PLAYER}
				name="FVP_CREATE_COPY_EXISTING_VIDEO_SECTION_ID_BTN"
				variant="contained"
				onClick={createVideoSection}
			>
				Create
			</GeneralButton>
		</div>
	);
};

export default CreateVideoSectionWithCopyExisting;
